module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pushes-wrapper"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.pushList), function(p) {
    return _c('div', {
      key: p.pushId,
      staticClass: "push"
    }, [_c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(p.description))]), _vm._v(" "), _c('div', {
      staticClass: "metrics"
    }, [_c('i', {
      staticClass: "fas fa-code-branch fa-lg fa-fw"
    }), _vm._v("\n\t\t\t" + _vm._s(p.targetBranch) + "\n\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "details"
    }, [_vm._v(_vm._s(p.relativeDateString) + " - " + _vm._s(p.dateString))])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('span', {
    staticClass: "header-icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Code Updates")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6feb3b31"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/dev-pushes.vue
// module id = 576
// module chunks = 0